// extracted by mini-css-extract-plugin
export default {"list":"NominatedList_list__N3FtG","container":"NominatedList_container__Ai6pb"};